var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.759V18.26c0 1.786 1.472 3.24 3.273 3.24h17.454C22.53 21.5 24 20.046 24 18.26V5.74c0-1.786-1.471-3.24-3.273-3.24H3.273C1.472 2.5 0 3.954 0 5.74v.019Zm2.286-.475c.175-.366.553-.623.987-.623h17.454c.434 0 .812.257.987.623L12 12.029 2.286 5.284ZM21.818 7.85v10.41c0 .589-.492 1.078-1.09 1.078H3.272c-.599 0-1.091-.49-1.091-1.079V7.85l8.858 6.152c.576.4 1.344.4 1.92 0l8.858-6.151Z",
    fill: "currentColor"
  })));
};
export default SvgEmail;